export const EPendingReferralDecision = {
  NO_ACTION: "NO_ACTION",
  CLOSE_CASE: "CLOSE_CASE",
  REFER: "REFER",
} as const;

export type EPendingReferralDecision =
  (typeof EPendingReferralDecision)[keyof typeof EPendingReferralDecision];
